import { useCallback } from 'react';

export const useSessionPersistence = () => {
    const saveSession = useCallback((sessionId) => {
        try {
            localStorage.setItem('marketingChainSessionId', sessionId);
            return true;
        } catch (error) {
            console.error('Error saving session to localStorage:', error);
            return false;
        }
    }, []);

    const getSavedSession = useCallback(() => {
        try {
            return localStorage.getItem('marketingChainSessionId');
        } catch (error) {
            console.error('Error getting session from localStorage:', error);
            return null;
        }
    }, []);

    const clearSession = useCallback(() => {
        try {
            localStorage.removeItem('marketingChainSessionId');
            return true;
        } catch (error) {
            console.error('Error clearing session from localStorage:', error);
            return false;
        }
    }, []);

    const saveSessionData = useCallback((sessionData) => {
        try {
            localStorage.setItem('marketingChainSessionData', JSON.stringify(sessionData));
            return true;
        } catch (error) {
            console.error('Error saving session data to localStorage:', error);
            return false;
        }
    }, []);

    const getSavedSessionData = useCallback(() => {
        try {
            const data = localStorage.getItem('marketingChainSessionData');
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error('Error getting session data from localStorage:', error);
            return null;
        }
    }, []);

    const clearSessionData = useCallback(() => {
        try {
            localStorage.removeItem('marketingChainSessionData');
            return true;
        } catch (error) {
            console.error('Error clearing session data from localStorage:', error);
            return false;
        }
    }, []);

    return {
        saveSession,
        getSavedSession,
        clearSession,
        saveSessionData,
        getSavedSessionData,
        clearSessionData
    };
}; 